import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-dark-secondary border-b border-gray-700">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/home" className="text-primary text-2xl font-bold">
              808 Lucky Six
            </Link>
            
            <div className="flex space-x-4">
              <Link
                to="/home"
                className={`px-4 py-2 rounded-lg transition ${
                  isActive('/home')
                    ? 'bg-primary text-white'
                    : 'text-gray-300 hover:text-white hover:bg-dark'
                }`}
              >
                Home
              </Link>
              
              <Link
                to="/my-entries"
                className={`px-4 py-2 rounded-lg transition ${
                  isActive('/my-entries')
                    ? 'bg-primary text-white'
                    : 'text-gray-300 hover:text-white hover:bg-dark'
                }`}
              >
                My Entries
              </Link>
              
              <Link
                to="/rules"
                className={`px-4 py-2 rounded-lg transition ${
                  isActive('/rules')
                    ? 'bg-primary text-white'
                    : 'text-gray-300 hover:text-white hover:bg-dark'
                }`}
              >
                Rules
              </Link>
              
              <Link
                to="/results"
                className={`px-4 py-2 rounded-lg transition ${
                  isActive('/results')
                    ? 'bg-primary text-white'
                    : 'text-gray-300 hover:text-white hover:bg-dark'
                }`}
              >
                Results
              </Link>

              {isAdmin && (
                <>
                  <Link
                    to="/admin/users"
                    className={`px-4 py-2 rounded-lg transition ${
                      isActive('/admin/users')
                        ? 'bg-primary text-white'
                        : 'text-gray-300 hover:text-white hover:bg-dark'
                    }`}
                  >
                    Users
                  </Link>
                  
                  <Link
                    to="/admin/weeks"
                    className={`px-4 py-2 rounded-lg transition ${
                      isActive('/admin/weeks')
                        ? 'bg-primary text-white'
                        : 'text-gray-300 hover:text-white hover:bg-dark'
                    }`}
                  >
                    Weeks
                  </Link>
                  
                  <Link
                    to="/admin/entries"
                    className={`px-4 py-2 rounded-lg transition ${
                      isActive('/admin/entries')
                        ? 'bg-primary text-white'
                        : 'text-gray-300 hover:text-white hover:bg-dark'
                    }`}
                  >
                    All Entries
                  </Link>
                  
                  <Link
                    to="/admin/settings"
                    className={`px-4 py-2 rounded-lg transition ${
                      isActive('/admin/settings')
                        ? 'bg-primary text-white'
                        : 'text-gray-300 hover:text-white hover:bg-dark'
                    }`}
                  >
                    Settings
                  </Link>
                </>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <span className="text-gray-300">
              {user?.username} {isAdmin && '(Admin)'}
            </span>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
